export const config = {
  email: 'business@rangein.io',
};
